import React from 'react'
import { t } from 'ttag'

import { DetailsCard } from 'components/shared/DetailsCard/DetailsCard'

export const DefaultDescription = () => (
  <React.Fragment>
    <DetailsCard.Text>{t`Prioritise the organisational goals important for the position and your organisation.`}</DetailsCard.Text>
    <DetailsCard.Text>{t`It is not possible to prioritise all three outcomes, as prioritising one will affect the others. If you choose not to prioritise any variables, they will be evaluated equally.`}</DetailsCard.Text>
  </React.Fragment>
)
